import React, { useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import emergency from "../assets/img/HomePage/emergency.svg";
import referral from "../assets/img/HomePage/referral.svg";
import guidance from "../assets/img/HomePage/guidance.svg";
import laws from "../assets/img/HomePage/laws.svg";
import ModalAbout from "../components/ModalAbout";
import { makeStyles } from "@mui/styles";
import Options from "../components/Options";
import { useDispatch, useSelector } from "react-redux";
import { changeTab } from "../redux/TabSlice";
import { getTitleFromAppContent, getContentTitle } from "../helpers/utils";
import { setBackToGuide } from "../redux/PageSlice";
import ArrowBack from "../assets/img/HumQadamHome/arrowBack.svg";
import SearchIcon from "@mui/icons-material/Search";
import { trackAppOpen, trackPageView } from "../helpers/api";

const useStyles = makeStyles((theme) => ({
  bgcolor: {
    background: "#FFFFFF",
  },
  textColor: {
    color: theme.palette.primary.main,
  },

  sectionbg: {
    background: theme.palette.primary.main,
  },

  sectionBgLight: {
    backgroundColor: "#F6F1F4",
  },

  emergencyBg: {
    backgroundColor: theme.palette.emergency.light,
  },

  emergencyTextBg: {
    backgroundColor: theme.palette.emergency.main,
  },
  referralBg: {
    backgroundColor: "#A94E76", // Light purple-pink for image area (matches Picture1)
  },

  referralTextBg: {
    backgroundColor: "#8E264E", // Dark purple-pink for text area (matches Picture1)
  },
  guidanceBg: {
    backgroundColor: theme.palette.guidance.light,
  },

  guidanceTextBg: {
    backgroundColor: theme.palette.guidance.main,
  },
  lawsBg: {
    backgroundColor: theme.palette.laws.light,
  },

  lawsTextBg: {
    backgroundColor: theme.palette.laws.main,
  },

  mHeigth: {
    minHeight: "800px",
    maxHeight: "800px",
  },
  // NEW: Search bar styles
  searchBar: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: "25px",
    padding: "10px 20px",
    margin: "0 auto 5px",
    cursor: "pointer",
    border: `1px solid ${theme.palette.primary.main}`,
    width: "544px", // 2 cards * (256px w-64 + 8px m-2) = 528px, rounded to 544px for better alignment
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      margin: "0 20px 5px",
    },
    "&:hover": {
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
  },
  searchText: {
    color: "#999",
    marginLeft: "10px",
    flex: 1,
  },
}));

const HumQadamHome = ({ onClose }) => {
  const classes = useStyles();
  const { selLanguageId } = useSelector((state) => state.language);
  const { selDistrictId } = useSelector((state) => state.district);
  const { selProvinceId } = useSelector((state) => state.province);
  const { appContent } = useSelector((state) => state.appContent);
  const [openAbout, setOpenAbout] = useState(false);
  const [tabSelect, setTabSelect] = useState("HumQadam");
  const [emergencyTitle, setEmergencyTitle] = useState("");
  const [referralTitle, setReferralTitle] = useState("");
  const [guidanceTitle, setGuidanceTitle] = useState("");
  const [lawsTitle, setLawsTitle] = useState("");
  const dispatch = useDispatch();
  const handleOpen = () => setOpenAbout(true);
  const handleClose = () => {
    setOpenAbout(false);
  };

  useEffect(() => {
    if (appContent && appContent.length > 0) {
      // Use app translations - all titles should be in the database
      setEmergencyTitle(getTitleFromAppContent(appContent, "Emergency Services"));
      // "Support Providing Organizations" might be stored as "Referral" in old database
      setReferralTitle(getContentTitle(appContent, ["Support Providing Organizations", "Referral", "Referral Guide"]));
      setGuidanceTitle(getTitleFromAppContent(appContent, "Step by Step Guidance"));
      setLawsTitle(getTitleFromAppContent(appContent, "Relevant Laws"));
    }
  }, [appContent]);

  // Track app open on mount (only once)
  const hasTrackedOpen = useRef(false);
  useEffect(() => {
    dispatch(setBackToGuide(false));
    
    // Track app open only once per session
    if (!hasTrackedOpen.current) {
      hasTrackedOpen.current = true;
      trackAppOpen({ province: selProvinceId, district: selDistrictId, language: selLanguageId });
    }
  }, [dispatch, selProvinceId, selDistrictId, selLanguageId]);

  useEffect(() => {
    dispatch(changeTab(tabSelect));
    
    // Track page navigation
    if (tabSelect && tabSelect !== "HumQadam") {
      trackPageView(tabSelect, { province: selProvinceId, district: selDistrictId, language: selLanguageId });
    }
  }, [tabSelect, dispatch, selProvinceId, selDistrictId, selLanguageId]);

  return (
    <div className={`${classes.sectionBgLight} flex flex-col justify-between`}>
      <div>
        <Header />
        <Options handleOpen={handleOpen} />
        
        {/* NEW: Search Bar */}
        <div
          className={classes.searchBar}
          onClick={() => setTabSelect("GlobalSearch")}
        >
          <SearchIcon color="primary" />
          <span className={classes.searchText}>
            {getTitleFromAppContent(appContent, "Search...") || "Search..."}
          </span>
        </div>
        
        <div className="px-5 mt-2 mb-48">
          <div className="flex flex-col sm:flex-row justify-center items-center">
            <div
              onClick={() => setTabSelect("EmergencyServices")}
              className={`m-2 w-64 h-52 flex-col justify-between flex cursor-pointer ${classes.emergencyBg} rounded-xl`}
            >
              <div>
                <img
                  src={emergency}
                  alt="Appstore"
                  className="px-3 py-5 h-32 mt-4 lg:mt-0 lg:h-36 mx-auto"
                />
              </div>
              <p
                className={`${classes.emergencyTextBg} text-center rounded-b-xl p-2 text-md text-white`}
              >
                {emergencyTitle}
              </p>
            </div>
            <div
              onClick={() => setTabSelect("ReferralDirectoryEntitiesGrid")}
              className={`m-2  w-64 h-52 flex-col justify-between flex cursor-pointer ${classes.referralBg} rounded-xl`}
            >
              <div>
                <img
                  src={referral}
                  alt="Appstore"
                  className="px-3 py-5 h-32 mt-4 lg:mt-0 lg:h-36 mx-auto"
                />
              </div>
              <p
                className={`${classes.referralTextBg} text-center rounded-b-xl p-2 text-md text-white`}
              >
                {referralTitle}
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row justify-center items-center">
            <div
              onClick={() => setTabSelect("StepGuide")}
              className={`m-2  w-64 h-52 flex-col justify-between flex cursor-pointer ${classes.guidanceBg} rounded-xl`}
            >
              <div>
                <img
                  src={guidance}
                  alt="Appstore"
                  className="px-3 py-5 h-32 mt-4 lg:mt-0 lg:h-36 mx-auto"
                />
              </div>
              <p
                className={`${classes.guidanceTextBg} text-center rounded-b-xl py-2 text-md text-white`}
              >
                {guidanceTitle}
              </p>
            </div>
            <div
              onClick={() => setTabSelect("Laws")}
              className={`m-2  w-64 h-52 flex-col justify-between flex cursor-pointer ${classes.lawsBg} rounded-xl`}
            >
              <div>
                <img
                  src={laws}
                  alt="Appstore"
                  className="px-3 py-5 h-32 mt-4 lg:mt-0 lg:h-36 mx-auto"
                />
              </div>
              <p
                className={`${classes.lawsTextBg} text-center rounded-b-xl p-2 text-md text-white`}
              >
                {lawsTitle}
              </p>
            </div>
          </div>
          <img
            alt="Arrow Back"
            onClick={() => onClose()}
            src={ArrowBack}
            className="mt-16 cursor-pointer self-start ml-5"
          />
        </div>
      </div>
      <div>
        <ModalAbout open={openAbout} handleClose={handleClose} />
      </div>
    </div>
  );
};

export default HumQadamHome;
